<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    class="news-page body__content"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="search-section">
      <div class="container">
        <el-row class="mb-3">
          <el-col
            :sm="24"
            :md="12"
          >
            <h1>Events</h1>
          </el-col>
          <el-col
            :sm="24"
            :md="12"
          >
            <el-button
              type="primary"
              class="pull-right"
              @click="openEventRequestDialog()"
            >
              Create new event
            </el-button>
          </el-col>
        </el-row>
        <el-form
          id="searchForm"
          ref="searchForm"
          :model="search"
          @submit.native.prevent
        >
          <el-row class="search-row align-items-center">
            <el-col
              :sm="24"
              :md="12"
            >
              <el-form-item prop="keyword">
                <template slot="label">
                  <span class="hidden-sm-and-down">Keyword search</span>
                </template>
                <el-input
                  id="keyword"
                  v-model="search.keyword"
                  placeholder="Search by keywords"
                  auto-complete="no"
                  maxlength="255"
                  @keyup.enter.native="searchEvents"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col
              :sm="24"
              :md="12"
            >
              <div class="search-events">
                <el-button
                  class="search-events-button"
                  type="primary"
                  @click="searchEvents"
                >
                  Search
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-row class="hidden-sm-and-down">
            <el-col
              :sm="24"
              :md="12"
              :lg="6"
            >
              <el-form-item
                prop="sortby"
                class="is-no-asterisk"
              >
                <template slot="label">
                  <span aria-hidden="true">Sort by</span>
                  <span class="sr-only">Choose from the following</span>
                </template>
                <v-select
                  v-model="search.sortby"
                  placeholder="Choose from the following"
                  :options="sortOptions"
                  :searchable="true"
                  :clearable="false"
                  :reduce="(sortOption) => sortOption.key"
                  input-id="sortby"
                  autocomplete="false"
                  label="name"
                  class="half-content"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="24"
              :md="12"
              :lg="6"
            >
              <el-form-item
                prop="locality"
                class="is-no-asterisk"
              >
                <template slot="label">
                  <span aria-hidden="true">Location</span>
                  <span class="sr-only">Please select a location</span>
                </template>
                <v-select
                  v-model="search.locality"
                  placeholder="Choose from the following"
                  :options="localities"
                  :searchable="true"
                  :clearable="false"
                  :reduce="(locality) => locality.slug"
                  input-id="locality"
                  autocomplete="false"
                  label="name"
                  class="half-content"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="24"
              :md="12"
              :lg="6"
            >
              <el-form-item
                prop="service"
                class="is-no-asterisk"
              >
                <template slot="label">
                  <span aria-hidden="true">Services</span>
                  <span class="sr-only">Please select a service</span>
                </template>
                <v-select
                  v-model="search.service"
                  placeholder="Choose from the following"
                  :options="services"
                  :searchable="true"
                  :clearable="false"
                  :reduce="(service) => service.slug"
                  input-id="service"
                  autocomplete="false"
                  label="name"
                  class="half-content"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="24"
              :md="12"
              :lg="6"
              class="d-flex mt-2"
            >
              <el-form-item class="is-no-asterisk">
                <div class="d-flex mt-4">
                  <el-button
                    type="text"
                    class="reset-btn"
                    @click="resetSearch"
                  >
                    Reset
                  </el-button>
                  <el-button
                    type="primary"
                    class="update-results-btn"
                    @click="searchEvents"
                  >
                    Update results
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="hidden-md-and-up">
            <el-col
              :sm="24"
              class="hidden-md-and-up"
            >
              <el-button
                class="more-filters-btn"
                size="medium"
                @click="openEventsFilter"
              >
                View More filters
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div
      v-if="showZeroData"
      class="zero-data text-center mt-5"
    >
      <div class="container">
        <el-row>
          <el-col :sm="24">
            <p>
              We could not find any events, with your search criteria. Please
              update your search and try again.
            </p>
          </el-col>
        </el-row>
      </div>
    </div>

    <div
      v-if="events.length > 0"
      id="main-content"
      class="results-section"
    >
      <div class="container">
        <div class="mt-4">
          <el-row>
            <events-card
              v-for="event in events"
              :key="event.id"
              :event="event"
            />
          </el-row>
        </div>
      </div>
    </div>

    <div class="pagination-help-section">
      <div class="container">
        <el-button
          v-if="events.length && !onLastPage"
          class="load-more-btn"
          size="medium"
          @click="fetchEvents"
        >
          Load more
        </el-button>
      </div>
    </div>

    <news-filter
      v-if="eventsFilterOpen"
      v-model="search"
      :sort-options="sortOptions"
      :services="services"
      :localities="localities"
      @close="closeEventsFilter"
      @search="searchEvents(true)"
      @reset="resetSearch(true)"
    ></news-filter>
    <event-request-dialog
      :key="eventRequestKey"
      :visible="showEventRequestDialog"
      :localities="localities"
      :services="services"
      @close="eventRequestDialogClosed()"
    />
  </div>
</template>

<script>
import store from "../../store";
import gsApi from "@/services/gs.api";
import EventsCard from "@/components/platform/events-webinars/events-card";
import NewsFilter from "@/components/slide-panel/panels/news-filter";
import EventRequestDialog from "@/components/platform/events-webinars/event-request-dialog";
import beWellCmsApi from "@/services/be-well-cms.api";

export default {
  name: "EventsAndWebinars",
  metaInfo: {
    title: "Events",
  },
  components: {
    "events-card": EventsCard,
    "news-filter": NewsFilter,
    EventRequestDialog,
  },
  data() {
    return {
      showEventRequestDialog: false,
      mainLoader: false,
      page: 1,
      perPage: 6,
      totalResults: 0,
      showZeroData: false,
      onLastPage: false,
      search: {
        sortby: "-created_at",
        keyword: "",
        service: null,
        locality: null,
      },
      sortOptions: [
        {
          key: "title",
          name: "A-Z",
        },
        {
          key: "-title",
          name: "Z-A",
        },
        {
          key: "-created_at",
          name: "Latest",
        },
      ],
      events: [],
      localities: [],
      services: [],
      eventsFilterOpen: false,
      eventRequestKey: +new Date(),
    };
  },
  created() {
    if (store.state.user.isLogged) {
      this.getRegisterMeta();
    }
  },
  methods: {
    getRegisterMeta() {
      this.mainLoader = true;

      gsApi.globalscot.meta
        .index()
        .then((response) => {
          this.localities = response.data.localities.data;
          this.services = response.data.services.data;
          this.fetchEvents();
        })
        .catch(() => {
          this.mainLoader = false;
          this.$alert(
            "An unknown error occurred. Please try again later.",
            "Error",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal",
            }
          );
        });
    },
    resetSearch(isMobile) {
      if (isMobile) {
        this.closeEventsFilter();
      }

      this.search = {
        sortby: "-created_at",
        keyword: "",
        service: null,
        locality: null,
      };

      this.searchEvents();
    },

    searchEvents(isMobile) {
      if (isMobile) {
        this.closeEventsFilter();
      }

      this.page = 1;
      this.events = [];
      this.fetchEvents();
    },
    fetchEvents() {
      if (!this.mainLoader) {
        this.mainLoader = true;
      }
      let params = {
        page: this.page,
        limit: this.perPage,
        "filter[content:contains]":
          this.search.keyword && this.search.keyword != ""
            ? this.search.keyword
            : null,
        "filter[taxonomy:services]": this.search.service ?? null,
        "filter[taxonomy:localities]": this.search.locality ?? null,
        sort: this.search.sortby,
      };

      beWellCmsApi
        .index("events", params)
        .then((response) => {
          this.mainLoader = false;

          this.totalResults = response.data.meta.total;

          if (
            response.data.meta.current_page !== response.data.meta.last_page
          ) {
            this.onLastPage = false;
            this.page++;
          } else {
            this.onLastPage = true;
          }

          this.events = this.events.concat(response.data.data);

          this.showZeroData = this.events.length > 0 ? false : true;
        })
        .catch(() => {})
        .finally(() => {
          this.mainLoader = false;
        });

      /*const webinar_sort =
        this.search.type === "Webinar" ? this.search.webinarType : null;
      const registered_user_id =
        this.search.type === "Event" && this.search.eventType === "my"
          ? this.$store.state.user.id
          : null;

      let params = {
        page: this.page,
        per_page: this.perPage,
        group: this.search.sector ? [this.search.sector] : null,
        search: this.search.keyword,
        type_id: this.search.filter,
        sort_by: this.search.sortby,
        webinar_sort: webinar_sort,
        status_id: 1,
        registered_user_id: registered_user_id,
        user_type_group_id: this.getUserTypeGroup(),
      };

      // temporary code
      if (this.search.type == "Event") {
        params.type_id = 0;
      } else if (this.search.type == "Webinar") {
        params.type_id = 1;
      } else if (this.search.type == "Podcast") {
        params.type_id = 2;
      }

      gsApi.events
        .search(params)
        .then((response) => {
          this.mainLoader = false;

          this.totalResults = response.data.meta.pagination.total;

          if (
            response.data.meta.pagination.current_page !==
            response.data.meta.pagination.total_pages
          ) {
            this.onLastPage = false;
            this.page++;
          } else {
            this.onLastPage = true;
          }

          this.events = this.events.concat(response.data.data);

          this.showZeroData = this.events.length > 0 ? false : true;
        })
        .catch((error) => {
          this.mainLoader = false;
        });*/
    },
    openEventsFilter() {
      this.eventsFilterOpen = true;
    },
    closeEventsFilter() {
      this.eventsFilterOpen = false;
    },
    handleSortChange(sort) {
      this.search.type = sort.label;
      this.searchEvents();
    },
    handleWebinarSortChange(sort) {
      this.search.webinarType = sort.label;
      this.searchEvents();
    },
    handleEventFilterChange(sort) {
      this.search.eventType = sort.label;
      this.searchEvents();
    },
    openEventRequestDialog() {
      this.showEventRequestDialog = true;
    },
    eventRequestDialogClosed() {
      this.showEventRequestDialog = false;
      this.eventRequestKey = +new Date();
    },
  },
};
</script>
<style lang="scss">
.search-btn:hover {
  background: transparent !important;
  color: black !important;
}
</style>
